import React from "react";
import { Form, Col } from "react-bootstrap";
import { DatePicker as RSDatePicker } from "rsuite";
import moment from "moment/min/moment-with-locales";
import { convertMomentToDatepickerFormat } from "../HelperFunctions";

export default function DatePicker({ formData, setFormData, predefinedRanges, latestAvailableDate }) {
    return (
        <Form.Group as={Col} className="col col-xl-1 min-w-date-picker">
            <Form.Label>Date</Form.Label>
            <RSDatePicker
                value={formData.date}
                onChange={value => setFormData({ ...formData, date: value })}
                placeholder="Select date"
                format={convertMomentToDatepickerFormat(moment.localeData(moment.locale()).longDateFormat("l"))}
                ranges={predefinedRanges}
                shouldDisableDate={date => moment(moment(date).startOf("day").format()).isAfter(moment(latestAvailableDate).local())}
                block
                oneTap
                isoWeek
                disabled={!formData.station.length}
            />
        </Form.Group>
    );
}

export const today = (dateOnly = false) => {
    const dt = moment().toDate();
    if (dateOnly) return dt;
    return { label: "Today", value: dt, placement: "left" };
};
export const latestAvailable = (date, dateOnly = false) => {
    const dt = moment(date).toDate();
    if (dateOnly) return dt;
    return { label: "Latest available", value: dt, placement: "left" };
};
export const lastWeek = (date, dateOnly = false) => {
    const dt = moment(date).subtract(1, "week").toDate();
    if (dateOnly) return dt;
    return { label: "Last week", value: dt, placement: "left" };
};
export const lastMonth = (date, dateOnly = false) => {
    const dt = moment(date).subtract(1, "month").toDate();
    if (dateOnly) return dt;
    return { label: "Last month", value: dt, placement: "left" };
};
